export default () => {
  return window._env_.REACT_APP_WEBSOCKET_SERVER;
}